<template>
  <div class="container">
    <form @submit.prevent="goNext">
      <HeadingOne class="-margin-md">収入証明書のご提出</HeadingOne>

      <ErrorsAlert :errors="errors"></ErrorsAlert>

      <WizardGroup class="_mb-sm-35 _mb-md-50">
        <MainWizard :active-index="0" type="income"></MainWizard>
      </WizardGroup>

      <slot name="message1"></slot>

      <section class="_mt-sm-20 _mt-md-30">
        <TableGroup>
          <TableBox class="-entry _mb-md-30 _mb-sm-20">
            <TableBody>
              <TableRow>
                <TableHeader> 収入証明書の選択 </TableHeader>
                <TableData>
                  <InputGroup>
                    <BtngroupRadio>
                      <BtnRadio
                        id="certificate01"
                        v-model="certificate"
                        name="certificate"
                        value="01"
                        >源泉徴収票</BtnRadio
                      >
                      <BtnRadio
                        id="certificate02"
                        v-model="certificate"
                        name="certificate"
                        value="02"
                        >給与明細書</BtnRadio
                      >
                      <BtnRadio
                        id="certificate03"
                        v-model="certificate"
                        name="certificate"
                        value="03"
                        >所得（課税）証明書</BtnRadio
                      >
                      <BtnRadio
                        id="certificate04"
                        v-model="certificate"
                        class="_font-sm"
                        name="certificate"
                        value="04"
                        >納税通知書（住民税決定通知書）</BtnRadio
                      >
                      <BtnRadio
                        id="certificate05"
                        v-model="certificate"
                        name="certificate"
                        value="05"
                        >確定申告書</BtnRadio
                      >
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>

        <slot name="message2"></slot>

        <TableGroup>
          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader> 年金を受給されていますか？ </TableHeader>
                <TableData>
                  <InputGroup>
                    <BtngroupRadio>
                      <BtnRadio
                        id="pension01"
                        v-model="pension"
                        name="pension"
                        value="01"
                        >受給していない</BtnRadio
                      >
                      <BtnRadio
                        id="pension02"
                        v-model="pension"
                        name="pension"
                        value="02"
                        >受給している</BtnRadio
                      >
                    </BtngroupRadio>
                  </InputGroup>
                  <div v-show="pension == '02'" class="_mt-15">
                    <InputLabel
                      >以下のいずれかの書類が必要となりますので、選択してください。</InputLabel
                    >
                    <InputGroup>
                      <BtngroupRadio>
                        <BtnRadio
                          id="identification01"
                          v-model="pensionDoc"
                          name="identification"
                          value="01"
                          >年金通知書</BtnRadio
                        >
                        <BtnRadio
                          id="identification02"
                          v-model="pensionDoc"
                          name="identification"
                          value="02"
                          >年金証書</BtnRadio
                        >
                      </BtngroupRadio>
                    </InputGroup>
                  </div>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
      </section>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="goNext">
          <span class="-spnone">ファイルの選択へ</span
          ><span class="-pcnone">アップロードする</span>
        </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { INCOME_CERTIFICATE_IMAGE_AT } from "@/constants/constant";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupRadio from "@/components/button/BtngroupRadio";
import BtnRadio from "@/components/button/BtnRadio";
import InputLabel from "@/components/input/InputLabel";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import InputGroup from "@/components/input/InputGroup";

export default {
  name: "IncomTop",
  components: {
    InputGroup,
    ErrorsAlert,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    BtnRadio,
    BtngroupRadio,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  props: {
    nextPageId: { type: String, default: "" },
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      certificate: null, // 収入証明書
      pension: "01", // 年金受給
      pensionDoc: null, // 年金書類
    };
  },
  mounted() {
    try {
      if (window.$cookies.get(INCOME_CERTIFICATE_IMAGE_AT)) {
        goToErrorPage("Image upload prohibited");
      }
    } catch (e) {
      goToErrorPage(e);
    }
    if (this.$route.query.certificate) {
      if (
        ["01", "02", "03", "04", "05"].indexOf(
          this.$route.query.certificate
        ) === -1
      ) {
        this.certificate = null;
      } else {
        this.certificate = this.$route.query.certificate;
      }
    }
    if (this.$route.query.pension) {
      if (["01", "02"].indexOf(this.$route.query.pension) === -1) {
        this.pension = "01";
      } else {
        this.pension = this.$route.query.pension;
      }
    }
    if (this.$route.query.pensionDoc) {
      if (["01", "02"].indexOf(this.$route.query.pensionDoc) === -1) {
        this.pensionDoc = null;
      } else {
        this.pensionDoc = this.$route.query.pensionDoc;
      }
    }
  },
  methods: {
    goNext() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.validateCertificate();
        this.validatePensionDoc();
        if (Object.keys(this.errors).length > 0) {
          this.isDisabled = false;
          scrollTop();
          return;
        }
        let queryParam = {
          certificate: this.certificate || "00",
          pension: this.pension || "01",
          pensionDoc: this.pension === "02" ? this.pensionDoc : "00",
        };
        this.$router.push({ name: this.nextPageId, query: queryParam });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    // 収入証明書チェック
    validateCertificate: function () {
      try {
        let reason = [];
        if (this.certificate) {
          if (["01", "02", "03", "04", "05"].indexOf(this.certificate) === -1) {
            this.certificate = null;
            reason.push("unselect");
          }
        } else {
          reason.push("unselect");
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {};
          this.errors["certificate"] = reason;
        }
      } catch (e) {
        goToErrorPage(e);
      }
    },
    // 年金書類チェック
    validatePensionDoc: function () {
      try {
        if (this.pension === "01") {
          return;
        }
        let reason = [];
        if (this.pensionDoc) {
          if (["01", "02"].indexOf(this.pensionDoc) === -1) {
            this.pensionDoc = null;
            reason.push("unselect");
          }
        } else {
          reason.push("unselect");
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {};
          this.errors["pensionDoc"] = reason;
        }
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

:deep(.input-label) {
  width: 100%;
  margin-bottom: 5px;
  color: $black !important;
}
</style>
